import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import PrintedUnclosedComponent from './printed-unclosed.component';
import ContentService from '../../services/content.service';
import ProfilePermissionsService from '../../services/profile-permissions.service';

let PrintedUnclosedModule = angular
  .module('PrintedUnclosed', [
    uiRouter
  ])
  .component('printedunclosed', PrintedUnclosedComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('printedUnclosed', {
      url: '/printed-unclosed',
      data: {
        authRequired: true
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'printedunclosed'
        }
      }
    })
  })
  .name;

export default PrintedUnclosedModule;



// WEBPACK FOOTER //
// ./src/app/pages/printed-unclosed/printed-unclosed.module.js